import React, { useState } from 'react';
import cn from 'classnames';
import VisuallyHidden from '@reach/visually-hidden';
import Collapsibles from '../components/Collapsibles';
import { breakpoints, colors } from '../config';
import iconClose from '../../assets/close.svg';
import '@reach/dialog/styles.css';
import { useGlobalData } from '../../store';

const Info = () => {
  const { globalData } = useGlobalData();

  const getTitle = prestamo => {
    let title;

    switch (prestamo) {
      case 'tarjeta':
        title = 'en tarjeta de crédito';
        break;
      case 'sobregiro':
        title = 'sobregiro en cuenta';
        break;
      case 'amortizable':
        title = 'amortizable';
        break;
      default:
        title = 'personal';
        break;
    }

    return title;
  };

  return (
    <div>
      <h3>Préstamo {getTitle(globalData.prestamo)}</h3>

      <ul>
        <li>
          <svg width={21} height={14} fill="none">
            <path
              d="M19.926 1.348L7.895 13.358a.84.84 0 01-.645.279.84.84 0 01-.645-.28L.998 7.771a.534.534 0 01-.172-.386.49.49 0 01.172-.387.468.468 0 01.365-.172c.158 0 .294.057.408.172l5.479 5.479L19.152.574c.1-.1.23-.15.387-.15.158 0 .287.05.387.15a.6.6 0 01.15.408c0 .144-.05.265-.15.366z"
              fill="#EC7000"
            />
          </svg>

          <span>Sin requisitos de documentación</span>
        </li>
        <li>
          <svg width={21} height={14} fill="none">
            <path
              d="M19.926 1.348L7.895 13.358a.84.84 0 01-.645.279.84.84 0 01-.645-.28L.998 7.771a.534.534 0 01-.172-.386.49.49 0 01.172-.387.468.468 0 01.365-.172c.158 0 .294.057.408.172l5.479 5.479L19.152.574c.1-.1.23-.15.387-.15.158 0 .287.05.387.15a.6.6 0 01.15.408c0 .144-.05.265-.15.366z"
              fill="#EC7000"
            />
          </svg>
          <span>Máximo de $450.000</span>
        </li>
        {/* <li>
          <svg width={21} height={14} fill="none">
            <path
              d="M19.926 1.348L7.895 13.358a.84.84 0 01-.645.279.84.84 0 01-.645-.28L.998 7.771a.534.534 0 01-.172-.386.49.49 0 01.172-.387.468.468 0 01.365-.172c.158 0 .294.057.408.172l5.479 5.479L19.152.574c.1-.1.23-.15.387-.15.158 0 .287.05.387.15a.6.6 0 01.15.408c0 .144-.05.265-.15.366z"
              fill="#EC7000"
            />
          </svg>
          <span>T.E.A.: desde 49%</span>
        </li> */}
      </ul>

      <style jsx>{`
        h3 {
          font-size: 18px;
          margin-bottom: 20px;
          margin-top: 0;
        }

        p {
          font-size: 16px;
          color: #757575;
          margin: 0;
          margin-bottom: 10px;
        }

        ul {
          font-size: 16px;
          list-style: none;
          padding-left: 0;
        }

        li {
          margin-bottom: 10px;
        }

        li svg {
          margin-right: 16px;
        }
      `}</style>
    </div>
  );
};

const Modal = ({ onDismiss = () => { }, defaultTab = 0 }) => {
  const [tab, setTab] = useState(defaultTab);

  return (
    <>
      <div className="modal-inner">
        <div className="modal-header">
          <div className="modal-tabs">
            <button
              type="button"
              className={cn('modal-tabs-button', { isActive: tab === 0 })}
              onClick={() => setTab(0)}
            >
              Información general
            </button>
            <button
              type="button"
              className={cn('modal-tabs-button', { isActive: tab === 1 })}
              onClick={() => setTab(1)}
            >
              Preguntas frecuentes
            </button>
          </div>

          <button className="close-button" onClick={onDismiss}>
            <VisuallyHidden>Cerrar</VisuallyHidden>
            <span aria-hidden>
              <img src={iconClose} alt="x" />
            </span>
          </button>
        </div>

        <div className="modal-body">
          {tab === 1 ? (
            <Collapsibles
              items={[
                {
                  title: '¿Cuáles son los requisitos para solicitar un préstamo?',
                  body: [
                    'Para solicitar un préstamo tenés que: tener un ingreso líquido superior a $23.000, no tener antecedentes negativos en Clearing de Informes, estar bien calificado en BCU, no tener deudas vencidas con el banco y abrir una cuenta en el banco.',
                    <br />,
                    <br />,
                    'Para solicitar un préstamo en tu tarjeta de crédito tenés que: tener una tarjeta de crédito activa con saldo disponible por el monto del préstamo que quieras solicitar y una cuenta donde se pueda acreditar el préstamo. De cumplir con los requisitos de Clearing ya podés solicitarlo y se acredita inmediatamente en tu cuenta.',
                    <br />,
                    <br />,
                    <>
                      Podés solicitar la apertura de la cuenta acá:{' '}
                      <a
                        href="https://www.itau.com.uy/inst/abriTuCuenta.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://www.itau.com.uy/inst/abriTuCuenta.html
                      </a>
                    </>,
                    <br />,
                    <>
                      Podés solicitar la tarjeta de crédito acá:{' '}
                      <a
                        href="https://www.itau.com.uy/inst/tarjetas.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://www.itau.com.uy/inst/tarjetas.html
                      </a>
                    </>,
                  ],
                },
                {
                  title: '¿Qué significa préstamo pre aprobado?',
                  body:
                    'Significa que, por tus ingresos o comportamiento dentro del banco, ya podés acceder a un préstamo. De cumplir con los requisitos de Clearing ya podés solicitarlo y se acredita inmediatamente en tu cuenta.',
                },
                {
                  title: '¿En cuántas cuotas puedo pedir un préstamo?',
                  body:
                    'Podés pedir un préstamo amortizable en 12, 18, 24, 36 o 48 cuotas o un préstamo en tu tarjeta de crédito en 6, 12, 18, 24 o 36 cuotas.',
                },
                {
                  title: '¿Cómo se pagan los préstamos?',
                  body: [
                    <>
                      <b>Si sos cliente:</b>
                    </>,
                    <br />,
                    'En el caso de un préstamo amortizable, las cuotas se cobran directamente desde tu cuenta del banco.',
                    <br />,
                    'En el caso de un préstamo en tu tarjeta de crédito, las cuotas se cobran mes a mes en el estado de cuenta de la tarjeta de crédito, como si fuera una compra en cuotas.',
                    <br />,
                    <br />,
                    <>
                      <b>Si no sos cliente:</b>
                    </>,
                    <br />,
                    'Las cuotas se cobran directamente desde la cuenta para pagos que te abriremos al momento de solicitar el préstamo. Previo al vencimiento deberás depositar en dicha cuenta el monto de la cuota para que el día de vencimiento se pueda debitar correctamente.',
                  ],
                },
                {
                  title: '¿Qué pasa si no tengo cuenta?',
                  body: [
                    <>
                      <b>Si sos cliente:</b>
                    </>,
                    <br />,
                    <>
                      Para poder otorgarte el préstamo amortizable, te abriremos una cuenta en donde
                      se acreditará el monto del préstamo y de donde se debitarán las cuotas mes a
                      mes.
                      <br />
                      Para el préstamo en tarjeta de crédito es necesario que poseas una cuenta
                      donde poder acreditar el monto del préstamo solicitado, podés solicitar la
                      apertura acá:{' '}
                      <a
                        href="https://www.itau.com.uy/inst/abriTuCuenta.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://www.itau.com.uy/inst/abriTuCuenta.html
                      </a>
                    </>,
                    <br />,
                    <br />,
                    <>
                      <b>Si no sos cliente:</b>
                    </>,
                    <br />,
                    'El monto del préstamo quedará disponible para que lo retires en Redpagos una vez que el mismo quede aprobado. Para el débito de las cuotas, te abriremos una cuenta para pagos de donde se debitarán las cuotas.',
                  ],
                },
                {
                  title: '¿Puedo cancelar las cuotas del préstamo antes de tiempo?',
                  body: [
                    'En el caso del préstamo amortizable sí. Para hacerlo es necesario que te dirijas a una sucursal del banco.',
                    <br />,
                    'En el caso del préstamo en tarjeta de crédito no es posible cancelar las cuotas antes de tiempo.',
                  ],
                },
                {
                  title: '¿Cómo puedo renovar mi préstamo?',
                  body: (
                    <>
                      Si sos cliente y ya pagaste la mitad + 1 de las cuotas totales de tu préstamo,
                      podés renovarlo ingresando en{' '}
                      <a href="https://www.itau.com.uy" target="_blank" rel="noopener noreferrer">
                        itau.com.uy
                      </a>{' '}
                      con tu documento y contraseña. Una vez que hayas ingresado, seleccionás el
                      préstamo que querés renovar, la cantidad de cuotas, la cuenta de la cual
                      querés que se debite el capital pendiente del préstamo anterior y la cuenta
                      donde querés que se acredite el préstamo nuevo. El débito del préstamo
                      anterior y el crédito del préstamo nuevo se realizarán en el momento.
                    </>
                  ),
                },
              ]}
            />
          ) : (
            <Info />
          )}
        </div>
      </div>

      <style jsx global>{`
        reach-portal {
          font-family: ${colors.baseFontDisplay};
          font-size: 15px;
          line-height: 1.5;
        }

        reach-portal :focus {
          outline: 0 !important;
        }

        reach-portal a {
          color: ${colors.orange};
          text-decoration: none;
        }

        reach-portal p {
          margin-bottom: 10px;
        }

        [data-reach-dialog-overlay] {
          align-items: flex-start;
          display: flex;
          overflow: hidden;
          z-index: 9999;
        }

        [data-reach-dialog-content] {
          background: transparent;
          margin: 10vw auto;
          padding: 0 !important;
          border-radius: ${colors.borderRadius};
        }

        @media screen and (max-width: ${breakpoints.md}) {
          [data-reach-dialog-content] {
            width: 90vw !important;
          }
        }
      `}</style>

      <style jsx>{`
        .modal-inner {
          background-color: ${colors.white};
          border-radius: ${colors.borderRadius};
          max-height: 80vh;
          overflow: scroll;
        }
        ::-webkit-scrollbar {
          display: none;
        }

        .modal-header {
          align-items: center;
          display: flex;
          font-family: ${colors.baseFontDisplay};
          font-size: 16px;
          padding: 24px;
          position: relative;
          padding-bottom: 0;
          border-bottom: 1px solid #efe9e5;
        }

        .modal-header strong {
          font-size: 18px;
          font-weight: 900;
        }

        .close-button {
          background: transparent;
          border: 0;
          cursor: pointer;
          font-family: inherit;
          margin: 0;
          padding: 0;
          position: absolute;
          right: 16px;
          top: 16px;
        }

        .modal-header-image {
          margin-right: 16px;
        }

        .modal-group-content {
          font-family: ${colors.baseFontDisplay};
          font-size: 16px;
          height: calc(80vh - 99px);
          overflow: scroll;
          padding: 24px;
        }

        .modal-group-content h3 {
          margin-bottom: 20px;
        }

        .modal-body {
          padding: 32px 48px;
        }

        .modal-tabs {
          display: flex;
        }

        .modal-tabs-button {
          padding: 0;
          font: inherit;
          border: 0;
          background: transparent;
          cursor: pointer;
          padding: 10px 20px;
          border-bottom: 3px solid transparent;
          font-size: 20px;
          cursor: pointer;
          color: #1c1c1c;
        }

        .modal-tabs-button.isActive {
          border-bottom-color: ${colors.orange};
        }
      `}</style>
    </>
  );
};

export default Modal;
